// Admin > Newsletter subscribers tab — filter chips + CSV export + table.
import { Download } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { fmt, csvDownload } from "./_helpers";

export default function SubscribersTab({ subs, subsFilter, setSubsFilter, loadSubs, loading }) {
  return (
    <div className="space-y-4" data-testid="admin-subscribers">
      <div className="flex gap-2 flex-wrap">
        {["active", "unsubscribed", "all"].map((s) => (
          <Button
            key={s}
            variant={subsFilter === s ? "default" : "outline"}
            size="sm"
            onClick={() => { setSubsFilter(s); loadSubs(s); }}
            data-testid={`subs-filter-${s}`}
            className={subsFilter === s ? "bg-primary text-primary-foreground hover:bg-primary/90" : ""}
          >
            {s.charAt(0).toUpperCase() + s.slice(1)}
          </Button>
        ))}
        <div className="flex-1" />
        <Button
          variant="outline"
          size="sm"
          onClick={() => csvDownload(
            "newsletter_subscribers.csv",
            subs,
            [
              { label: "Email", get: (r) => r.email },
              { label: "Name", get: (r) => r.name || "" },
              { label: "Source", get: (r) => r.source || "" },
              { label: "Subscribed", get: (r) => r.subscribed_at || "" },
              { label: "Unsubscribed", get: (r) => r.unsubscribed_at || "" },
            ],
          )}
          data-testid="subs-export"
        >
          <Download size={14} className="mr-1.5" /> Export CSV
        </Button>
      </div>

      <Card className="border-border shadow-none rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 text-left text-xs uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="px-4 py-3">Email</th>
                <th className="px-4 py-3">Name</th>
                <th className="px-4 py-3">Source</th>
                <th className="px-4 py-3">Subscribed</th>
                <th className="px-4 py-3">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {subs.length === 0 ? (
                <tr><td colSpan={5} className="px-4 py-10 text-center text-muted-foreground">{loading ? "Loading…" : "No subscribers"}</td></tr>
              ) : subs.map((s) => (
                <tr key={s.id} data-testid={`subs-row-${s.id}`}>
                  <td className="px-4 py-3 font-medium">{s.email}</td>
                  <td className="px-4 py-3">{s.name || "—"}</td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">{s.source || "—"}</td>
                  <td className="px-4 py-3 text-xs text-muted-foreground">{s.subscribed_at ? fmt(s.subscribed_at) : "—"}</td>
                  <td className="px-4 py-3">
                    {s.unsubscribed_at ? (
                      <span className="text-xs text-muted-foreground">Unsubscribed</span>
                    ) : (
                      <span className="inline-flex items-center gap-1 rounded-md bg-primary/10 text-primary px-2 py-0.5 text-xs font-medium">Active</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
